/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ClassifierType {
    NONE = 'none',
    INSTITUTION_TYPE = 'institutionType',
    DEVICE_TYPE = 'deviceType',
    DEPARTMENT_GROUP = 'departmentGroup',
    IC_D10AM = 'icD10AM',
    CUATM = 'cuatm',
    COUNTRIES = 'countries',
    TREATMENT_TYPE = 'treatmentType',
    ACCUSE = 'accuse',
    TEST_TYPE = 'testType',
    CANCELLATION_REASON = 'cancellationReason',
    RETURN_REASON = 'returnReason',
    WRITE_OFF_REASON = 'writeOffReason',
    INTERNAL_RETURN_REASON = 'internalReturnReason',
    PRODUCT_PART_STATE = 'productPartState',
    INSTITUTION_CLASSIFICATION = 'institutionClassification',
    CONSULTATION_TYPE = 'consultationType',
    DISEASE_PROGRESS = 'diseaseProgress',
    DISEASE_OUTCOME = 'diseaseOutcome',
    EPIDEMIOLOGY_CASE_CLASSIFICATION = 'epidemiologyCaseClassification',
    PERSON_SOCIAL_STATUS = 'personSocialStatus',
    PREGNANCY_STATUS = 'pregnancyStatus',
    PREGNANCY_MONITORING_PERIOD = 'pregnancyMonitoringPeriod',
    PREGNANCY_TYPE = 'pregnancyType',
    MEDICAL_INSTITUTION = 'medicalInstitution',
    SPECIMEN_TYPE = 'specimenType',
    MEASURE_UNIT = 'measureUnit',
    TREATMENT_TYPE_REGIMEN = 'treatmentTypeRegimen',
    INVESTIGATION_CATEGORY = 'investigationCategory',
    INFECTION = 'infection',
    WORK_METHOD = 'workMethod',
    INVESTIGATION_WORK_METHOD_DOMAIN = 'investigationWorkMethodDomain',
    INVESTIGATION_UNIT_MEASURE = 'investigationUnitMeasure',
    SPECIMEN_STORAGE_CONDITION = 'specimenStorageCondition',
    INVESTIGATION_RESULT_TYPE = 'investigationResultType',
    INVESTIGATION_RESULT_OPTION = 'investigationResultOption',
    REFERENCE_INTERVAL = 'referenceInterval',
    INVESTIGATION_TYPE = 'investigationType',
    INVESTIGATION_RESULT_VALUE_OPTION = 'investigationResultValueOption',
    INVESTIGATION_TEST_TYPE = 'investigationTestType',
    CONTACT_TYPE = 'contactType',
    MEDICAL_SPECIALTY = 'medicalSpecialty',
    STOCK_PRODUCT_SERVICE = 'stockProductService',
    INSTITUTION_SERVICE = 'institutionService',
    INQUIRY_UPDATE_REASON = 'inquiryUpdateReason',
    REPORT_CATEGORY = 'reportCategory',
    RISK_GROUP = 'riskGroup',
    TESTING_CONTINGENT = 'testingContingent',
    PREVENTION_TREATMENT_CONTINGENT_TYPE = 'preventionTreatmentContingentType',
    ONG_FUNDING_SOURCE = 'ongFundingSource',
    RISK_GROUP_EXCLUSION_REASON = 'riskGroupExclusionReason',
    SIDA_AIDS_ESTABLISHMENT_REASON = 'sidaAidsEstablishmentReason',
    HIV_SCREENING_TEST_METHOD = 'hivScreeningTestMethod',
    HIV_CONFIRMATION_TEST_METHOD = 'hivConfirmationTestMethod',
    HIV_MOTHER_STATUS = 'hivMotherStatus',
    HIV_TRANSMISSION_ROUTE = 'hivTransmissionRoute',
    AIDS_CLINICAL_CATEGORY = 'aidsClinicalCategory',
    AIDS_CLINICAL_CONDITIONS_A = 'aidsClinicalConditionsA',
    AIDS_CLINICAL_CONDITIONS_B = 'aidsClinicalConditionsB',
    AIDS_CLINICAL_CONDITIONS_C = 'aidsClinicalConditionsC',
}
